module.exports = __webpack_public_path__ + "img/home-title4.6b5e7094.png";